import { Box, VStack } from '@chakra-ui/react';
import { Input } from '@/components/v4';
import { textBoxStyling } from '../formStyles';

const NumberField = ({
    field,
    displayPrefix,
    // Consume non-DOM props so they don't leak onto the underlying <input>
    inputProps: _inputProps,
    inputComponent: _inputComponent,
    darkMode: _darkMode,
    error: _error,
    customWidth = '90%',
    width,
    noPadding,
    ...props
}) => (
    <Box
        sx={{
            display: 'flex',
            width: width || '100%',
            alignItems: 'flex-start',
            paddingTop: noPadding ? '0' : '15px',
        }}>
        <VStack width={customWidth} alignItems="normal">
            <Input
                {...field}
                {...props}
                displayPrefix={displayPrefix}
                type="number"
                sx={textBoxStyling}
                data-walkthroughid={props.walkthroughid}
                onWheel={(e) => e.target.blur()}
            />
        </VStack>
    </Box>
);
export default NumberField;
